module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "clock",
    attrs: {
      "header": "Pomodoro Clock",
      "header-variant": "success"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row-disp"
  }, [_c('div', [(_vm.sessionState || _vm.breakState) ? _c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.startOrPause
    }
  }, [_c('i', {
    staticClass: "fa fa-pause fa-2x"
  })]) : _c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.startOrPause
    }
  }, [_c('i', {
    staticClass: "fa fa-play fa-2x"
  })])], 1), _vm._v(" "), _c('div', [_c('CurrentTime')], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('i', {
    staticClass: "fa fa-stop fa-2x"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row-disp"
  }, [_c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('session', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Session time\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.sessionDiffMin) + "\n            :\n            " + _vm._s(_vm.sessionDiffSec) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.sessionTime) + " min(s)\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('session', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('circle', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Circles\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.circles) + "\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('circle', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('break', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Break time\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.breakDiffMin) + "\n            :\n            " + _vm._s(_vm.breakDiffSec) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.breakTime) + " min(s)\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('break', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.sessionInt) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("On")]) : _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Off")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760620ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 16
// module chunks = 0